import React, { useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MegaphoneIcon from '@atlaskit/icon/core/megaphone';

import {
	FeedbackType,
	useFeedbackCollector,
} from '@confluence/company-hub-utils/entry-points/FeedbackCollectorLoader';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';

import type { EllipsisDropdownComponentProps } from './types';

const i18n = defineMessages({
	shareFeedback: {
		id: 'editor-ellipsis-dropdown.open.ellipsis.hub.share-feedback',
		description:
			'The dropdown menu item in the editor the user can click to open a modal to share their feedback on the feature Company Hub',
		defaultMessage: 'Give feedback on Company hub',
	},
});

export function useCompanyHubSettingsGroupMenuItems({
	spaceKey,
}: Pick<EllipsisDropdownComponentProps, 'spaceKey'>) {
	const isCompanyHub = isCompanyHubSpaceKey(spaceKey);

	const openFeedbackCollector = useFeedbackCollector({
		source: 'hubEditorEllipsisDropdown',
		type: FeedbackType.COMPANY_HUB,
	});

	return useCallback(
		(menuItems: JSX.Element[]) => {
			if (!isCompanyHub) {
				return;
			}

			menuItems.push(
				<DropdownItemGroup hasSeparator={menuItems.length >= 1} key="company-hub-settings-items">
					<DropdownItem
						key="share-feedback"
						elemBefore={<MegaphoneIcon label="" />}
						onClick={openFeedbackCollector}
					>
						<FormattedMessage {...i18n.shareFeedback} />
					</DropdownItem>
				</DropdownItemGroup>,
			);
		},
		[isCompanyHub, openFeedbackCollector],
	);
}
